var map = {
	"./android.png": 779,
	"./aws.png": 3693,
	"./azure-repos.png": 3443,
	"./bitbucket.png": 3733,
	"./bootstrap.png": 9652,
	"./ci-cd.png": 1590,
	"./clean-code.png": 9759,
	"./communication.png": 7622,
	"./css.png": 2687,
	"./design-patterns.png": 3392,
	"./docker.png": 1768,
	"./firebase.png": 7219,
	"./gcp.png": 8808,
	"./github.png": 9449,
	"./gitlab.png": 6705,
	"./gradle.png": 1253,
	"./habit.png": 2296,
	"./html.png": 5887,
	"./ios.png": 1949,
	"./java.png": 8768,
	"./javascript.png": 2721,
	"./jetpack-compose.png": 2419,
	"./jira.png": 1420,
	"./kotlin.png": 3339,
	"./kubernetes.png": 7256,
	"./maven.png": 1991,
	"./mongo-db.png": 9459,
	"./my-image.png": 4034,
	"./mysql.png": 4568,
	"./node-js.png": 1946,
	"./react.png": 6843,
	"./realm.png": 1247,
	"./room.png": 273,
	"./servicehub.png": 3526,
	"./simform_logo.png": 9751,
	"./solid.png": 9347,
	"./spendwise.png": 1478,
	"./spring-boot.png": 4418,
	"./storyboard.png": 2649,
	"./swift-ui.png": 4080,
	"./swift.png": 5367,
	"./tailwind-css.png": 9218,
	"./tdd.png": 2758,
	"./xml.png": 8333,
	"./zoho.png": 5282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;